<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="titlea"><span class="bold">The Killer of the Princes in the Tower</span></h1>
<p class="title"><span class="bold">A New Suspect Revealed</span></p>
<p class="author"><span class="bold">M. J. Trow</span></p>
<div class="image_container">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?1ea1bd0e